<!-- 我的收藏更多操作 -->
<template>
  <div>
    <!-- 文件夹操作菜单 -->
    <van-action-sheet :actions="folderMoreList" v-model="showFolder" cancelText="取消" class="uActionSheetStyle" @close="close" @select="selectFolder" />
    <!-- 文件操作菜单 -->
    <van-action-sheet :actions="fileMoreList" v-model="showFile" cancelText="取消" class="uActionSheetStyle" @close="close" @select="selectFile" />

    <!-- 属性弹框 -->
    <van-popup v-model="attributeShow" position="bottom">
      <div class="attributeContent">
        <div class="attributeItem">
          <span>文档路径：</span>
          <span class="attributeItemData">{{ Pitem.favoriteName }}</span>
        </div>
        <div class="attributeItem">
          <span>收藏时间：</span>
          <span class="attributeItemData">{{ Pitem.operDate }}</span>
        </div>
        <div class="attributeItem">
          <span>备注：</span>
          <span class="attributeItemData">{{ Pitem.remark || "--" }}</span>
        </div>
      </div>
      <div class="attributeClose" @click="attributeClose">取消</div>
    </van-popup>
    <!-- 分享弹框 -->
    <van-popup v-model="shareShow" position="bottom" round @open="shareOpen" @close="shareShow = false">
      <div class="shareStyle">
        <qrcode ref="qrcode" v-if="shareShow"></qrcode>
        <van-button type="info" round plain @click="saveQrcode">保存图片</van-button>
        <div class="linkText">{{ "链接：" + shareLink.url }}</div>
        <span class="linkBtn" @click="copyUrl(shareLink.url)">复制链接</span>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Notify } from "vant";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import { downloadFile, downloadUrltoken, downloadFileShowPrompt } from "@/CommonDP/utils";
import docService from "@/CommonDP/service/doc-service";
import getDateTime from "@/CommonDP/utils/getDateTime.js";
import qrcode from "../../components/qrcode.vue";

export default {
  components: { qrcode },
  data() {
    return {
      // 文件夹操作菜单
      folderMoreList: [],
      folderPriviList: [
        // { name: "下载", Privi: this.$allPerms.MYCOLLECTION_DOWN },
        { name: "分享", Privi: this.$allPerms.MYCOLLECTION_SHARE },
        { name: "属性", Privi: "" },
        { name: "取消收藏", Privi: "" }
      ],
      // 文件操作菜单
      fileMoreList: [],
      filePriviList: [
        // { name: "下载", Privi: this.$allPerms.MYCOLLECTION_DOWN },
        { name: "分享", Privi: this.$allPerms.MYCOLLECTION_SHARE },
        { name: "属性", Privi: "" },
        { name: "取消收藏", Privi: "" }
      ],
      showFolder: false,
      showFile: false,
      Pitem: {}, // 当前操作的文档

      attributeShow: false, // 属性弹框
      shareShow: false, // 分享弹框
      shareLink: {} // 分享链接
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId, // 当前企业Id
      userInfo: (state) => state.user.userInfo
    })
  },
  onLoad() {},
  mounted() {},
  methods: {
    // 设置文件夹权限
    setFolderPrivi(items) {
      this.Pitem = items || {};
      this.folderMoreList = this.folderPriviList.filter((item) => (item.Privi ? checkPermission(item.Privi) : true));
      this.showFolder = true;
    },
    // 设置文件权限
    setFilePrivi(items) {
      this.Pitem = items || {};
      this.fileMoreList = this.filePriviList.filter((item) => (item.Privi ? checkPermission(item.Privi) : true));
      this.showFile = true;
    },
    // 关闭事件
    close() {
      this.showFolder = false;
      this.showFile = false;
    },

    // 文件夹菜单事件
    selectFolder(val) {
      if (val.name === "下载") this.downloadDoc(this.Pitem);
      if (val.name === "分享") this.shareDoc();
      if (val.name === "属性") this.queryAttribute();
      if (val.name === "取消收藏") this.cancelCollect();
    },
    // 文件菜单事件
    selectFile(val) {
      if (val.name === "下载") this.downloadDoc(this.Pitem);
      if (val.name === "分享") this.shareDoc();
      if (val.name === "属性") this.queryAttribute();
      if (val.name === "取消收藏") this.cancelCollect();
    },

    // 下载文件
    async downloadDoc(row) {
      const prjId = "MyDoc";
      const { userId } = this.userInfo || {};
      if (row.isFolder !== 1) {
        const fileId = row.folderId;
        const version = row.fileVersion;
        const downzipurl = downloadUrltoken(prjId, fileId, version);
        downloadFile(downzipurl);
      } else {
        const params = {
          folderId: row.folderId,
          rootDirectory: row.folderName,
          prjId: prjId,
          enterpriseId: this.enterpriseId,
          userId: userId
        };
        docService.downloadfolder(params).then((response) => {
          const fileName = row.folderName + ".zip";
          downloadFileShowPrompt(fileName, response);
        });
      }
    },
    // 属性
    queryAttribute() {
      this.close();
      this.attributeShow = true;
    },
    // 关闭属性
    attributeClose() {
      this.attributeShow = false;
    },
    // 取消收藏
    async cancelCollect() {
      let { folderId, folderName, isFolder } = this.Pitem || {};
      const params = {
        folderId,
        folderName,
        isFolder,
        prjId: this.enterpriseId
      };
      await docService.deletePersonFavorite(params);
      Notify({ type: "success", message: "取消收藏成功!" });
      this.close();
      this.$emit("toRefresh");
    },

    // 分享
    async shareDoc() {
      this.shareLink = {}; // 清空分享链接数据
      let prjId = "MyDoc"; // 企业文档
      let endDate = getDateTime(null, "y-m-d h:m:s", 1); // 默认为一天后
      let { folderId, isFolder, folderName } = this.Pitem;
      let file = { id: folderId, isFile: isFolder, name: folderName };
      let params = {
        prjId,
        enterpriseId: this.enterpriseId,
        folderList: [file],
        isNeedPwd: 1, // 普通链接和二维码不需要密码   0是需要密码
        endDate: endDate,
        isDownload: 1, // 允许下载
        isEdit: 1,
        title: folderName,
        isOut: 1,
        shareSource: 1 // 个人文档为1  企业文档为2
      };
      const res = await docService.genShareNewLink(params);
      this.shareLink = res.data || {};
      this.close();
      this.shareShow = true;
    },
    // 分享弹框打开
    shareOpen() {
      this.$nextTick(() => {
        this.$refs.qrcode.qrCreate(this.shareLink.url);
      });
    },
    // 保存二维码到相册
    saveQrcode() {
      this.$refs.qrcode.qrSave();
    },
    //复制链接
    copyUrl(url) {
      if (url) {
        this.$copyText(url).then(() => {
          Notify({ type: "success", message: "链接复制成功!" });
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .uActionSheetStyle {
  .van-action-sheet__content {
    max-height: 50vh;
  }
  .van-action-sheet__item {
    border-bottom: 1px solid #e5e8f1 !important;
    .van-action-sheet__name {
      font-size: 16px;
      color: var(--key-color);
    }
  }

  .van-action-sheet__cancel {
    font-size: 16px;
    color: #007af5;
  }

  .van-action-sheet__gap {
    height: 1px !important;
    background-color: #e5e8f1 !important;
  }
}

.attributeContent {
  max-height: 240px;
  padding: 20px;

  .attributeItem {
    white-space: nowrap;
    overflow: overlay !important;
    overflow: auto;
    span {
      font-size: 16px;
      line-height: 40px;
    }
    .attributeItemData {
      color: var(--key-color);
    }
  }
}

.attributeClose {
  border-top: 1px solid #e5e8f1 !important;
  font-size: 16px !important;
  color: #007af5 !important;
  line-height: 50px;
  text-align: center;
}

.shareStyle {
  width: 100vw;
  padding: 30px 5vw 40px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .van-button {
    width: 120px;
    margin-top: 20px;
  }

  .linkText {
    width: 100%;
    margin-top: 20px;
    font-size: 14px;
    color: var(--key-color);
    word-break: break-all;
  }

  .linkBtn {
    margin-top: 20px !important;
    font-size: 14px;
    color: #007af5;
    cursor: pointer;
  }
}
</style>
